// User actions
export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';

// MerchantData actions
export const RECEIVE_MERCHANT_DATA = 'RECEIVE_MERCHANT_DATA';
export const RECEIVE_ACCOUNT_REP_DATA = 'RECEIVE_ACCOUNT_REP_DATA';

// Statements actions
export const RECEIVE_STATEMENTS = 'RECEIVE_STATEMENTS';
export const RECEIVE_STATEMENT = 'RECEIVE_STATEMENT';
